/**
 * Feature Flags for MVP Launch
 *
 * Set features to false to disable them in the UI.
 * Disabled features:
 * - Won't appear in dashboard
 * - Routes will redirect to home
 *
 * After launch, enable features incrementally.
 */

export const featureFlags = {
  // CORE - Always enabled for MVP
  dashboard: true,
  search: true, // Basic order search
  ordrelogg: false,
  utlevering: false, // "Utlevering" dashboard button - reserved for future use
  orderImport: true, // import → pending
  orderPending: true, // pending → delivered
  orderDelivered: true,
  customerOrders: true,
  photos: true,

  // DISABLED for MVP - enable after launch
  pckPocket: true, // Advanced article/order line search
  verksted: false, // Service/workshop module
  admin: false, // Admin panel
  parking: true, // Park orders
  splitOrder: true, // Split/partial deliveries
} as const

export type FeatureFlag = keyof typeof featureFlags

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return featureFlags[flag]
}
